"use client";

import * as React from "react";
import { Compass, Anchor, Sailboat, Map, Telescope, Ship, TreePalm, Sun } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "Oceanic Explorers",
  icon: Compass
}, {
  id: 2,
  name: "Deep Sea Ventures",
  icon: Anchor
}, {
  id: 3,
  name: "Windward Yachts",
  icon: Sailboat
}, {
  id: 4,
  name: "Global Navigators",
  icon: Map
}, {
  id: 5,
  name: "Stargazer Cruises",
  icon: Telescope
}, {
  id: 6,
  name: "Maritime Alliance",
  icon: Ship
}, {
  id: 7,
  name: "Tropical Retreats",
  icon: TreePalm
}, {
  id: 8,
  name: "Solar Journeys",
  icon: Sun
}];
export default function SignaturePartnerships() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const rows = [partners.slice(0, 4), partners.slice(4, 8)];
  return;
}